module.exports = __webpack_public_path__ + "img/number-3.cf7b3919.png";